import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const useGoTo = () => {
  const history = useHistory()
  const [page, setPage] = useState(null)

  useEffect(() => {
    if (page) {
      history.push({
        pathname: page.path,
        search: page.search
      })
      setPage(null)
    }
  }, [history, page])

  const goTo = (path, search) => {
    setPage({ path, search })
  }

  return goTo
}

export default useGoTo
